module.exports = __webpack_public_path__ + "img/pre-university-office.b1f4265d.png";